<template>
    <section class="promotion">
        <van-tabbar v-model="active" @change="changeTabbar" active-color="#098bef" inactive-color="#9BA5B7">
            <van-tabbar-item name="customer">
                <span>线索</span>
                <template #icon="props">
                    <img :src="props.active ? customerActivedIcon : customerUnactivedIcon" />
                </template>
            </van-tabbar-item>

            <van-tabbar-item name="promotion" v-if="token && accountType == 0">
                <span>计划</span>
                <template #icon="props">
                    <img :src="props.active ? promotionActivedIcon : promotionUnactivedIcon" />
                </template>
            </van-tabbar-item>

            <van-tabbar-item name="setting">
                <span>我的</span>
                <template #icon="props">
                    <img :src="props.active ? settingActivedIcon : settingUnactivedIcon" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
        <Login :isLoginModel="isLoginModel" :type="type" :topLeftArrow="topLeftArrow" @closeModel="isLoginModel = false"
            @loginStatus="loginStatus" @loginModelFn="loginModelFn" />

        <van-nav-bar title="计划" class="top_bar" @click-right="promotionPlusFn">
            <template #right v-if="token && accountType == 0">
                <van-icon color="#333" name="add-o" size="24" />
            </template>
        </van-nav-bar>
        <van-tabs v-model="planStatusTab" @change="onPlanStatusTabChange" swipeable animated color="#098bef">
            <van-tab title="全部" name="all" />
            <van-tab title="推广中" name="1" />
            <van-tab title="已暂停" name="2" />
            <van-tab title="已完成" name="3" />
        </van-tabs>
        <section v-if="isData" class="data_class">
            <van-list v-model="loading" @load="loadMore" :immediate-check="false" :finished="finished"
                finished-text="已全部加载完成">
                <van-cell class="group" v-for="(item, id) in list" :key="id" @click="skipPlanDetails(item.id)">
                    <div class="head">
                        <h3>{{ item.planName }}</h3>
                    </div>
                    <div class="content">
                        <div class="block" v-if="item.planStatus == 0">
                            <div class="detail">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"
                                    fill="none">
                                    <g clip-path="url(#clip0_198_764)">
                                        <mask id="mask0_198_764" style="mask-type:luminance" maskUnits="userSpaceOnUse"
                                            x="0" y="0" width="19" height="19">
                                            <path d="M18.5 0.5H0.5V18.5H18.5V0.5Z" fill="white" />
                                        </mask>
                                        <g mask="url(#mask0_198_764)">
                                            <path
                                                d="M10.25 5C12.1302 5.31725 13.6827 6.86975 14 8.75H17C16.6468 5.21225 13.7878 2.35324 10.25 2V5Z"
                                                fill="#EF7A0E" />
                                            <path
                                                d="M14 10.25C13.6415 12.3747 11.7636 13.9617 9.53825 13.9617C7.05655 13.9617 5.03827 11.9435 5.03827 9.46175C5.03827 7.23649 6.62524 5.3585 8.75 5V2C4.96548 2.378 2.03827 5.57974 2.03827 9.46175C2.03827 13.5972 5.40274 16.9617 9.53825 16.9617C13.4203 16.9617 16.622 14.0345 17 10.25H14Z"
                                                fill="#D31972" />
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_198_764">
                                            <rect width="18" height="18" fill="white" transform="translate(0.5 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <p class="title">待生效</p>
                        </div>
                        <div class="block" v-if="item.planStatus == 1">
                            <div class="detail">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15"
                                    fill="none">
                                    <path
                                        d="M12 9.23205C13.3333 8.46225 13.3333 6.53775 12 5.76795L3.75 1.00481C2.41667 0.23501 0.75 1.19726 0.75 2.73686V12.2631C0.75 13.8027 2.41667 14.765 3.75 13.9952L12 9.23205Z"
                                        fill="#0DDEF4" />
                                </svg>
                            </div>
                            <p class="title">推广中</p>
                        </div>
                        <div class="block" v-if="item.planStatus == 2">
                            <div class="detail">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15"
                                    fill="none">
                                    <rect x="0.5" y="0.5" width="4.00011" height="14.0004" rx="1" fill="#0DDEF4" />
                                    <rect x="8.49965" y="0.5" width="4.00011" height="14.0004" rx="1" fill="#0DDEF4" />
                                </svg>
                            </div>
                            <p class="title">已暂停</p>
                        </div>
                        <div class="block" v-if="item.planStatus == 3">
                            <div class="detail">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14"
                                    fill="none">
                                    <path
                                        d="M6.76784 13.5129C6.57273 13.708 6.25644 13.7082 6.06112 13.5133L0.353819 7.81833C0.158391 7.62332 0.157995 7.30683 0.352934 7.11134L2.08612 5.37323C2.28118 5.17761 2.59791 5.17725 2.79342 5.37241L6.0577 8.63091C6.25301 8.82588 6.56935 8.82574 6.76449 8.6306L15.2036 0.191446C15.3989 -0.00381711 15.7155 -0.0038178 15.9107 0.191445L17.6464 1.92717C17.8417 2.12243 17.8417 2.43902 17.6464 2.63428L6.76784 13.5129Z"
                                        fill="#0DDEF4" />
                                </svg>
                            </div>
                            <p class="title">已完成</p>
                        </div>
                        <div class="block" v-if="item.planStatus == 4">
                            <div class="detail">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                    fill="none">
                                    <rect width="12" height="12" rx="2" fill="#CED7E2" />
                                </svg>
                            </div>
                            <p class="title">已终止</p>
                        </div>
                        <div class="block" v-if="item.planStatus == 5">
                            <div class="detail">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                    fill="none">
                                    <rect width="12" height="12" rx="2" fill="#CED7E2" />
                                </svg>
                            </div>
                            <p class="title">已取消</p>
                        </div>
                        <div class="block">
                            <div class="detail">
                                <p>{{ item.customerCount }}</p>
                            </div>
                            <p class="title">获客数</p>
                        </div>
                        <div class="block">
                            <div class="detail">
                                <p>{{ Math.floor(item.actualConsumption / 100) + "." }}</p>
                                <span>{{
                                    (item.actualConsumption / 100).toFixed(2).toString().slice(-2)
                                    }}</span>
                            </div>
                            <p class="title">已消耗</p>
                        </div>
                        <div class="block">
                            <div class="detail">
                                <p>{{ Math.floor(item.averageCustomerCost / 100) + "." }}</p>
                                <span>{{
                                    (item.averageCustomerCost / 100)
                                        .toFixed(2)
                                        .toString()
                                    .slice(-2)
                                    }}</span>
                            </div>
                            <p class="title">获客成本</p>
                        </div>
                        <div class="block">
                            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11"
                                fill="none">
                                <path d="M1 1L5 5.30769L1 9.61538" stroke="#727F92" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </van-cell>
            </van-list>
        </section>
        <section v-if="!token || !isData" class="nodata_class">
            <div class="no_data">
                <img src="../../assets/img/promotion_default.png" />
                <p>点击右上角创建推广计划</p>
            </div>
        </section>
        <section v-if="accountType == 1 || accountType == 2" class="nodata_class">
            <div class="no_data">
                <img src="../../assets/img/promotion_default.png" />
                <p>无查看权限</p>
            </div>
        </section>
    </section>
</template>

<script>
import Login from "components/Login";
import promotionServer from "api/promotion";
import settingServer from "api/setting";
import { Toast } from "vant";

import promotionActivedIcon from "assets/img/flowsheet_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import promotionUnactivedIcon from "assets/img/flowsheet_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";
import customerActivedIcon from "assets/img/contact_phone_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import customerUnactivedIcon from "assets/img/contact_phone_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";
import settingActivedIcon from "assets/img/account_circle_124dp_098BEF_FILL0_wght400_GRAD0_opsz48.png";
import settingUnactivedIcon from "assets/img/account_circle_124dp_D9D9D9_FILL0_wght400_GRAD0_opsz48.png";

export default {
    name: "promotion",
    components: {
        Login,
    },
    data() {
        return {
            promotionActivedIcon,
            promotionUnactivedIcon,
            customerActivedIcon,
            customerUnactivedIcon,
            settingActivedIcon,
            settingUnactivedIcon,

            token: "",
            active: 'promotion',
            isData: 1,
            isLoginModel: false,
            topLeftArrow: true,
            type: "login",

            params: {
                pageNum: 0,
                pageSize: 10,
            },
            list: [],
            loading: false,
            finished: false,

            accountType: "",

            accountInfo: {},
            orgInfo: {},
            planStatusTab: 'all',
        };
    },

    created() {
        this.token = localStorage.getItem("token");
        this.accountType = localStorage.getItem("accountType");

        if (this.token && this.accountType == 0) {
            this.loadMore();

            this.getAccountInfo();
        }
    },

    mounted() {
        if (this.$store.state.clientType == 2) {
            document.addEventListener("plusready", function () {
                var webview = plus.webview.currentWebview();
                plus.key.addEventListener("backbutton", function () {
                    webview.canBack(function (e) {
                        if (e.canBack) {
                            webview.back();
                        } else {
                            webview.close();
                        }
                    });
                });
            });
        }
    },

    methods: {
        getOrgInfo() {
            settingServer.getOrgInfo().then((res) => {
                this.orgInfo = res.data
            })
        },

        getAccountInfo() {
            settingServer.getAccountInfo().then((res) => {
                this.accountInfo = res.data
            })
        },

        changeTabbar() {
            if (this.active == "team") {
                this.$router.push({ name: "team" });
            }

            if (this.active == "promotion") {
                this.$router.push({ name: "promotion" });
            }

            if (this.active == "customer") {
                this.$router.push({ name: "customer" });
            }

            if (this.active == "setting") {
                this.$router.push({ name: "setting" });
            }
        },

        //登录回调
        loginStatus(status) {
            if (status == "ok") {
                this.isLoginModel = false;

                this.token = localStorage.getItem("token");
                this.accountType = localStorage.getItem("accountType");

                if (this.token && this.accountType == 0) {
                    this.loadMore();
                }
            }
        },

        loginModelFn(type) {
            if (type == "login") {
                this.topLeftArrow = true;
            } else {
                this.topLeftArrow = false;
            }
            this.type = type;
            this.isLoginModel = true;
        },

        onPlanStatusTabChange() {
            this.params.pageNum = 0;
            this.list = [];
            this.finished = false;
            if (this.planStatusTab === 'all') {
                this.params.planStatus = undefined;
            } else {
                this.params.planStatus = Number(this.planStatusTab);
            }
            this.loadMore(true);
        },

        loadMore(reset = false) {
            this.loading = true;
            if (reset) {
                this.params.pageNum = 1;
                this.list = [];
                this.finished = false;
            } else {
                this.params.pageNum++;
            }
            promotionServer.getPromotionPageList(this.params).then((res) => {
                this.loading = false;
                if (res.data.total > 0) {
                    this.isData = 1;
                } else {
                    this.isData = 0;
                    this.list = [];
                }
                if (res.data.list.length > 0) {
                    this.list = this.list.concat(res.data.list);
                }
                if (res.data.boolLastPage) {
                    this.finished = true;
                }
            });
        },

        promotionPlusFn() {
            if (!this.token) return (this.isLoginModel = true)

            if (this.accountInfo.authenticationStatus != 2) return Toast('请先完成账户认证')

            if (this.accountInfo.orgAuthenticationStatus != 2) return Toast('请先完成机构认证')

            if (this.accountInfo.subscriptionStatus != 1) return Toast('请先完成订阅')

            if (this.accountType == 1 || this.accountType == 2) return Toast("无权限操作")

            this.$router.push({ name: "promotion-add" });
        },

        skipPlanDetails(id) {
            this.$router.push({ name: "promotion-details", params: { id: id } });
        },
    },
};
</script>

<style lang="scss">
.promotion {
    padding-top: 44px;
    padding-bottom: 83px;

    .data_class {
        position: relative;
        width: 100%;
        border-radius: 24px;
        background: #fdfdfd;

        .group {
            padding: 28px;
            padding-left: 0;
            margin-left: 28px;
            border-bottom: 1px solid #e9f0f8;
            width: auto;
            line-height: 1;
            background: inherit;
            font-size: inherit;
            color: inherit;

            .head {
                display: flex;
                align-items: center;

                h3 {
                    font-size: 15px;
                    color: #4d5b80;
                    margin-right: 18px;
                    max-width: 75%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                span {
                    font-size: 11px;
                    line-height: 22px;
                    padding: 0 3.5px;
                    border-radius: 2px;
                }

                span.credit {
                    color: #055ce8;
                    background-color: rgba(5, 92, 232, 0.054);
                }

                span.car {
                    color: #ef7a0e;
                    background-color: rgba(222, 112, 16, 0.054);
                }

                span.house {
                    color: #19b128;
                    background-color: rgba(25, 177, 40, 0.054);
                }

                span.insurance {
                    color: #d31972;
                    background-color: rgba(211, 25, 114, 0.054);
                }

                span.company {
                    color: #162ae1;
                    background-color: rgba(22, 42, 225, 0.054);
                }
            }

            .content {
                display: flex;
                justify-content: space-between;

                .block {
                    height: 49px;
                    margin-top: 14px;
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    justify-content: center;

                    p.title {
                        font-size: 11px;
                        line-height: 22px;
                        color: rgba(45, 54, 79, 0.9);
                    }

                    .detail p {
                        font-size: 22px;
                        line-height: 22px;
                        color: #4d5b80;
                        display: inline-block;
                    }

                    .detail span {
                        font-size: 12px;
                        line-height: 22px;
                        color: #4d5b80;
                        display: inline-block;
                    }
                }

                .block:first-child {
                    padding-right: 17px;
                    border-right: 1px solid #dbdde1;
                    display: flex;
                    align-items: center;
                }
            }
        }
    }

    .nodata_class {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #f8f8f8;
        display: flex;
        align-items: center;
        justify-content: center;

        .no_data {
            position: relative;
            top: -100px;

            img {
                width: 252px;
                display: inline-block;
            }

            p {
                padding-top: 22px;
                color: #4d5b80;
                font-size: 16px;
                text-align: center;
            }
        }
    }

    .van-cell::after {
        border: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/index/Promotion.vue